/* eslint-disable */
<template>
  <div>
    <div class="product-image">
      <flickity
        v-if="thumbs && thumbs.length > 0"
        ref="flickity"
        :options="flickityImageOptions"
        class="flickity">
        <div
          v-for="image in thumbs"
          class="card carousel-cell-image">
          <img
            :src="base_url+image"
            alt=""
            @error="replaceByDefault">
        </div>
      </flickity>
    </div>
    <!--    </div>-->
    <div class="row">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">{{ vatpham.name }}</h4>
          <div class="card-text">
            <div class="sale-price">{{ vatpham.price_sale }} đ</div>
            <div class="price">{{ vatpham.price }} đ</div>
          </div>
          <div class="clearfix"/>
          <div class="sale_up_to">tiết kiệm {{ vatpham.price_save }} đ</div>
          <center>
            <b-button
              class="btn btn-order btn-pri"
              @click="addToCart()">Mua ngay
            </b-button>
          </center>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="content">
        <div class="text-header">Quyền lợi khách hàng</div>
        <ul>
          <li><i class="fa fa-check"/> Hoàn tiền 100% nếu phát hiện hàng giả</li>
          <li><i class="fa fa-check"/> Cam kết hàng chính hãng</li>
          <li><i class="fa fa-check"/> Bảo hành đổi trả theo yêu cầu</li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="content">
        <div class="text-header">Thông tin chi tiết</div>
        <table class="table table-striped">
          <tbody>
            <tr>
              <td>Thương hiệu</td>
              <td>{{ info_item.thuong_hieu ? 'Viện phong thủy Hoàng Gia Việt Nam' : info_item.thuong_hieu }}</td>
            </tr>
            <tr>
              <td>Sản xuất tại</td>
              <td>{{ info_item.thuoc_tinh }}</td>
            </tr>
            <tr>
              <td>Kích thước</td>
              <td>{{ info_item.kich_thuoc }}</td>
            </tr>
            <tr>
              <td>Mã sản phẩm</td>
              <td>{{ info_item.ma_sanpham }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="content">
        <div class="text-header">Mô tả sản phẩm</div>
        <div class="panel-wrapper">
          <div
            class="panel_read_more"
            v-html="description"/>
          <button
            v-if="sliding && vatpham.description && vatpham.description.length >= 250"
            class="show_read_mode btn_read_mode btn-customer"
            @click="onSlideStart()">Xem chi tiết
          </button>
          <button
            v-if="!sliding"
            class="show_read_mode btn_read_mode btn-customer"
            @click="onSlideEnd()">Rút gọn
          </button>
          <div class="fade"/>
        </div>
      </div>

      <div class="my-card">
        <div class="header-card">
          <div class="header-card-left pull-left">Sản phẩm tương tự ?</div>
          <div class="header-card-right pull-right">
            <router-link to="/items">Xem thêm</router-link>
          </div>
          <div class="clearfix"/>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="col-xs-12">
              <flickity
                v-if="similar && similar.length > 0"
                ref="flickity"
                :options="flickityOptions"
                class="flickity">
                <div
                  v-for="item in similar"
                  class="card carousel-cell">
                  <product-item :item="item"/>
                </div>
              </flickity>
            </div>
          </div>
        </div>
      </div>

      <p-t-dialog :vatpham="cart"/>
    </div>
  </div>

</template>
<script>
  import rating from '../include/rating'
  import carousel from 'vue-owl-carousel'
  import rf from '../../communicate/RequestFactory'
  import ApiConfig from '../../communicate/ApiConfig'
  import PTDialog from '../shared/PtDialog'
  import Flickity from 'vue-flickity'
  import ProductItem from "../categories/ProductItem";
  import defaultImage from '../../assets/images/default-avatar.png';
  import {warnToaster} from '../../services/ErrorHandler'

  export default {
    name: 'ItemDetail',

    components: {
      ProductItem,
      PTDialog,
      rating: rating,
      carousel: carousel,
      Flickity
    },

    data: function () {
      return {
        showModal: false,
        id: this.$route.params.id,
        description: '',
        sliding: true,
        vatpham: {},
        thumbs: [],
        similar: [],
        info_item: {},
        is_favourite: false,
        errors: [],
        base_url: ApiConfig.base_url,
        cart: {},
        flickityOptions: {
          initialIndex: 4,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          freeScroll: true,
          autoPlay: 5000
        },
        flickityImageOptions: {
          initialIndex: 1,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          freeScroll: true,
          autoPlay: 5000
        }
      }
    },

    watch: {
      $route (to, from) {
        this.loadDetailVatPham(to.params.id);
      }
    },

    mounted () {
      this.loadDetailVatPham(this.id);
    },

    methods: {
      onSlideStart () {
        this.sliding = false;
        this.description = this.vatpham.description;
      },

      onSlideEnd () {
        this.sliding = true;
        this.description = this.vatpham.description ? this.vatpham.description.substring(0, 250) + '...' : '';
      },

      loadDetailVatPham (id) {
        this.sliding = true;
        rf.getRequest("ItemRequest").getItemDetail(id).then((res) => {
          this.vatpham = res.data.item;
          this.info_item = res.data.info_item;
          this.thumbs = res.data.thumb;
          this.similar = res.data.similar;
          this.is_favourite = res.data.favourite !== 0;
          this.description = this.vatpham.description ? this.vatpham.description.substring(0, 250) + '...' : '';
        }).catch(err => {
          this.errors.push(err.message);
        })
      },

      addToCart () {
        this.saveCartToLocalStorage();
      },

      saveCartToLocalStorage () {
        const cartsListStorage = localStorage.getItem('carts');
        const cartlist = cartsListStorage ? JSON.parse(cartsListStorage) : [];
        if (!this.vatpham.id) {
          warnToaster('Cố Vấn Phong Thủy', 'Xảy ra lỗi trong quá trình lưu giỏ hàng');
          return;
        }

        const tempVp = cartlist.filter(obj => obj.id === this.vatpham.id);

        const cartItem = {
          id: this.vatpham.id,
          name: this.vatpham.name,
          image: this.thumbs && this.thumbs.length > 0 ? this.thumbs[0] : '',
          count: 1,
          price_sale: this.vatpham.price_sale,
          price: this.vatpham.price
        };
        if (!tempVp || tempVp.length === 0) {
          cartlist.push(cartItem);
        } else {
          for (const cart of cartlist) {
            if (cart.id === this.vatpham.id) {
              cart.count++;
            }
          }
        }
        localStorage.setItem('carts', JSON.stringify(cartlist));
        this.$store.dispatch('updateCart');
        this.showDialog(cartItem);
      },

      showDialog (data) {
        this.cart = data;
        this.$bvModal.show('cart_info_dlg');
      },

      replaceByDefault (e) {
        e.target.src = defaultImage;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .cart {
    width: 100%;
    display: flex;
  }

  .cart .cart-left {
    flex-basis: 35%;
  }

  .cart .cart-right {
    flex-basis: 65%;
  }

  .cart-right .cart-body {
    margin-left: 10px;
  }

  .cart-right .cart-body h5 {
    font-size: 0.9rem;
  }

  .cart-right .xuat_xu {
    color: #efefef;
  }

  .cart-right .xuat_xu span {
    color: #000;
  }

  .cart-right .cart-body p {
    font-size: 0.6rem;
    color: #418AEB;
  }

  .cart-name {
    font-size: 1rem;
  }

  .card-title {
    margin-bottom: 5px;
    font-size: 1.1rem;
    padding: 0 10px 5px 10px;
  }

  .card-text {
    padding: 0 10px;
  }

  #detail-item {
    margin: 15px 0 5px 0;
  }

  .card {
    margin-bottom: 10px;
    width: 100%;
    border-radius: unset;
    border: none;
  }

  .progress, .progress-bar {
    height: 3px
  }

  .card-body {
    padding: 10px;
  }

  .card-body h5 {
    font-size: 1rem;
  }

  .sale-price, .price {
    float: left;
    margin-right: 20px;
    margin-top: 5px;
  }

  .price {
    font-size: 0.9rem;
    text-decoration: line-through;
    margin-top: 8px;
  }

  .sale_up_to {
    margin-top: 5px;
    color: #448DEE;
    font-size: 11px;
    padding: 0 10px;
  }

  .sale-price {
    font-size: 1.2rem;
    color: #FF5755;
  }

  .sale-price_1, .price_1 {
    float: left;
    margin-right: 3px;
    margin-top: 5px;
  }

  .sale-price_1 {
    font-size: 0.9rem;
    color: #FF5755;
  }

  .price_1 {
    font-size: 0.7rem;
    text-decoration: line-through;
    padding: 3px 0 0 5px;
  }

  .fa-check {
    color: #4189EB !important;
  }

  .modal-header .fa-check {
    padding: 3px;
    border-radius: 50%;
  }

  .fa-close {
    padding: 3px 4px;
    border-radius: 50%;
    border: 1px solid #2a2a2a;
  }

  .content .text-header {
    font-size: 16px;
    padding-bottom: 10px;
  }

  .content ul {
    margin-left: 10px;
  }

  .content ul li {
    /*font-size: 14px;*/
    padding-bottom: 5px;
  }

  .table {
    margin-bottom: 0px;
  }

  .point_rating {
    font-size: 28px;
  }

  .panel-wrapper {
    position: relative;
  }

  .rating-right .fa {
    font-size: 13px;
  }

  .btn_read_mode {
    color: #000;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 5px;
    padding: 0.5em 0;
    text-decoration: none;
    width: 100%;
    border: 1px solid #DDDDDD;
    font-size: 15px;
  }

  .show_read_mode, .hide_read_mode {
    position: absolute;
    bottom: 0;
    z-index: 10;
    text-align: center;
  }

  .line-rating div[data-v-cce46000] {
    font-size: 11px;
  }

  .hide_read_mode {
    display: none;
  }

  .show_read_mode:target {
    display: none;
  }

  .show_read_mode:target ~ .hide_read_mode {
    display: block;
  }

  .show_read_mode:target ~ .panel_read_more {
    max-height: 2000px;
    font-size: 14px;
  }

  .show:target ~ .fade {
    margin-top: 0;
  }

  .panel_read_more {
    position: relative;
    margin: 1em auto;
    width: 100%;
    font-size: 15px;
    overflow: hidden;
    transition: max-height .5s ease;
    white-space: pre-line;
  }

  .fade {
    background: rgba(255, 255, 255, 0.1);
    height: 90px;
    margin-top: -50px;
    position: relative;
  }

  .rating-detail {
    width: 100%;
    display: -webkit-flex; /* Safari */
    display: flex;
  }

  .rating-left {
    width: 40%;
    float: left;
    border-right: 1px solid #DDDDDD;
    padding: 0 10px;
  }

  .rating-right {
    float: left;
    width: 60%;
    padding-top: 10px;
  }

  .line-rating .fa-star {
    font-size: 10px;
  }

  .line-rating {
    width: 100%;
    display: -webkit-flex;
    display: flex;
    margin-left: 10px;
  }

  .line-rating div {
    -webkit-flex-grow: 0; /* Safari 6.1+ */
    -webkit-flex-shrink: 0; /* Safari 6.1+ */
    -webkit-flex-basis: 20%; /* Safari 6.1+ */
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 20%;
    margin-bottom: -3px;
  }

  .line-rating div:nth-of-type(3) {
    -webkit-flex-basis: 20%;
    flex-basis: 10%;
  }

  .line-rating div:nth-of-type(2) {
    -webkit-flex-basis: 20%;
    flex-basis: 70%;
    margin-top: 4px;
    margin-right: 15px;
  }

  .line-rating div:nth-of-type(1) {
    -webkit-flex-basis: 20%;
    flex-basis: 14%;
  }

  .content .card {
    border: 1px solid #e2e2e2;
  }

  .content .card-body {
    padding: 0 10px 10px 10px;
  }

  .btn-comment {
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
    font-family: 'Roboto', sans-serif;
    font-size: 13px;
    letter-spacing: 1px;
    font-weight: 400;
    color: #000;
    background: #efefef;
    border: none;
    padding: 8px 0;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
  }

  ol, ul {
    margin-bottom: 0;
  }

  .carousel-cell {
    width: 50%;
    height: 400px;
    margin-right: 10px;
    background: white;
    border-radius: 5px;
  }

  .product-image {
    margin: 0px -15px;

    .carousel-cell-image {
      width: 100%;
      height: 260px;
      margin-right: 10px;
      background: white;
      border-radius: 5px;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  .btn-customer {
    padding: 10px 0;
    border-radius: 45px;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    outline: none;
    background: #4189EB;
    color: #fff;
    border: none;
  }

  .btn-customer:hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
    background: #4189EB;
    color: #fff;
  }

  .btn-pri {
    background: #4189EB;
    color: #fff;
    border-radius: 45px;
  }

  @media screen and (max-width: 900px) {
    .line-rating div:nth-of-type(3) {
      flex-basis: 5%;
    }

    .line-rating div:nth-of-type(2) {
      flex-basis: 45%;
      margin-right: 10px;
    }

    .line-rating div:nth-of-type(1) {
      flex-basis: 30%;
    }

    .modal-container {
      width: 98%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/item/ItemDetail.vue